import Header from '../../../components/Header';
import React, { useEffect, useState, useMemo, memo, useRef } from 'react';
import { Box, Typography, Button, Grid, useTheme, IconButton, TextField, InputAdornment, MenuItem, Select, FormControl, useMediaQuery, Dialog, DialogContent, DialogActions } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import SearchIcon from '@mui/icons-material/Search';
import { format } from 'date-fns';
import 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import { getAllPaymentVendor, getVendorPayment } from '../../../redux/slice/vendorPayment.slice';


function Venderpayment() {
  const isMobile = useMediaQuery('(max-width:1150px)');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const purchase = useSelector(state => state.vendorPayment.purchaseData)
  const isMobileee = useMediaQuery('(max-width:500px)');

  useEffect(() => {
    dispatch(getVendorPayment())
    dispatch(getAllPaymentVendor())

  }, [dispatch]);

  const navigate = useNavigate()
  const handleEdit = (purchaseId, _id) => {
    navigate('/admin/add-vendor-payment', { state: { purchaseId: purchaseId, _id } });
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [isImage, setIsImage] = useState(false);

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [selectedStatus1, setSelectedStatus1] = useState("0");

  const statusCounts = useMemo(() => {
    const counts = {
      Pending: 0,
      "Partial-Pending": 0,
      Complete: 0,
      Total: 0,
    };

    purchase?.forEach((v) => {
      const VendorPay = v.venderPayments?.[0];
      const Allstatus = v.storeData?.[0]?.amountTotal.toString();
      const Allstatus1 = VendorPay?.VendorPaymentDetails?.reduce(
        (total, payment) => total + Number(payment.VendorPaymentTotal),
        0
      ).toString();

      const pendingPayment = Allstatus - Allstatus1;

      counts.Total += 1;

      if (pendingPayment < 0) {
        counts.Complete += 1;
      } else if (Allstatus1 === undefined || Allstatus === undefined) {
        counts.Pending += 1;
      } else if (Allstatus1 < Allstatus) {
        counts["Partial-Pending"] += 1;
      } else if (Allstatus === Allstatus1 && Allstatus !== undefined) {
        counts.Complete += 1;
      }
    });

    return counts;
  }, [purchase]);

  const [searchTerm, setSearchTerm] = useState('');

  const filteredPurchases = useMemo(() => {
    let filtered = purchase;

    if (selectedStatus1 !== "0") {
      filtered = purchase.filter((v) => {
        const VendorPay = v.venderPayments?.[0];
        const Allstatus = v.storeData?.[0]?.amountTotal.toString();
        const Allstatus1 = VendorPay?.VendorPaymentDetails?.reduce(
          (total, payment) => total + Number(payment.VendorPaymentTotal),
          0
        ).toString();
        const pendingPayment = Allstatus - Allstatus1;

        if (selectedStatus1 === "Pending" && (Allstatus1 === undefined || Allstatus === undefined)) {
          return true;
        }
        if (selectedStatus1 === "Partial-Pending" && Allstatus1 < Allstatus && pendingPayment >= 0) {
          return true;
        }
        if (selectedStatus1 === "Complete" && (Allstatus === Allstatus1 && Allstatus !== undefined || pendingPayment < 0)) {
          return true;
        }
        return false;
      });
    }

    if (searchTerm?.trim()) {
      const searchLower = searchTerm.toLowerCase().trim();
      const searchNumber = searchLower.replace('%', '');

      filtered = filtered.filter((v) => {
        const VendorPay = v.venderPayments?.[0];
        const relatedStoreEntries = v.purchaseDetails?.[0];
        const totalReceivedQty = relatedStoreEntries?.multipleQty?.reduce((acc, curr) => acc + curr.recieveQty, 0);

        const totalPayment = relatedStoreEntries?.amountTotal;
        const tdsTcsAmount = Number(VendorPay?.VendorPaymentDetails?.reduce(
          (total, payment) => total + Number(payment.VendorPaymentTDS), 0
        )) || 0;
        const accountPayment = Number(VendorPay?.VendorPaymentDetails?.reduce(
          (total, payment) => total + Number(payment.VendorPaymentTotal), 0
        )) || 0;
        const pendingPayment = totalPayment - accountPayment || 0;

        const paymentPercentage = ((accountPayment * 100) / totalPayment) || 0;
        const paymentPercentageStr = paymentPercentage % 1 === 0 ?
          `${paymentPercentage.toFixed(0)}%` :
          `${paymentPercentage.toFixed(3)}%`;

        const materialPercentage = totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1);
        const materialPercentageStr = materialPercentage % 1 === 0 ?
          `${materialPercentage.toFixed(0)}%` :
          `${materialPercentage.toFixed(2)}%`;

        return (

          v.SrNo?.toString().toLowerCase().includes(searchLower) ||
          (v.PurchaseDate && format(new Date(v.PurchaseDate), 'dd-MM-yyyy').includes(searchLower)) ||
          v.amountTotal?.toString().includes(searchLower) ||
          v.vendorDetails?.[0]?.businessName?.toLowerCase().includes(searchLower) ||
          v.wareHouseDetails?.[0]?.wareHouseName?.toLowerCase().includes(searchLower) ||

          paymentPercentageStr.includes(searchLower) ||
          materialPercentageStr.includes(searchLower) ||
          (paymentPercentage.toFixed(3).includes(searchNumber) ||
            materialPercentage.toFixed(2).includes(searchNumber)) ||

          totalPayment?.toString().includes(searchLower) ||
          tdsTcsAmount.toString().includes(searchLower) ||
          accountPayment.toString().includes(searchLower) ||
          pendingPayment.toString().includes(searchLower) ||

          v.venderPayments?.[0]?.VendorPaymentDetails?.some(payment =>
            payment.VendorPaymentTotal?.toString().includes(searchLower) ||
            payment.VendorPaymentTDS?.toString().includes(searchLower)
          )
        );
      });
    }

    return filtered;
  }, [selectedStatus1, purchase, searchTerm]);

  return (

    <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
      <Header
        title="VENDOR PAYMENT"
        subtitle="Manage Your Vendor Payment Here"
      />
      <Box sx={{ display: { xs: "block", md: "flex" }, justifyContent: 'space-between' }}>

        <FormControl size="small" sx={{ display: { xs: 'block', md: 'inline-flex' } }}>
          <Select
            value={selectedStatus1}
            onChange={(event) => setSelectedStatus1(event.target.value)}
            sx={{
              minWidth: '100%',
              [theme.breakpoints.up('sm')]: {
                // minWidth: '200px',
                minWidth: '300px',
              },
              [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            }}
          >
            <MenuItem value="0">All Data ({statusCounts.Total})</MenuItem>
            <MenuItem value="Pending">Pending ({statusCounts.Pending})</MenuItem>
            <MenuItem value="Partial-Pending">Partial-Pending ({statusCounts["Partial-Pending"]})</MenuItem>
            <MenuItem value="Complete">Complete ({statusCounts.Complete})</MenuItem>
          </Select>
        </FormControl>

        <TextField
          variant="outlined"
          size="small"
          placeholder="Search..."
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: '100%',
            mt: { xs: 2, md: 0 },
            [theme.breakpoints.up('sm')]: {
              minWidth: '300px',
            },
            [theme.breakpoints.down('sm')]: {
              minWidth: '100%',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#566585',
              },
              '&:hover fieldset': {
                borderColor: '#566585',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            },
          }}
        />
      </Box>

      {filteredPurchases?.length > 0 ? (
        filteredPurchases?.map((v) => {
          const VendorPay = v.venderPayments?.[0];
          const vedoerpending = VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0) || 0
          console.log("VENDOR PAY", VendorPay)
          const relatedStoreEntries = v.storeData?.[0];
          console.log(relatedStoreEntries?.amountTotal - vedoerpending)
          const totalReceivedQty = relatedStoreEntries?.multipleQty?.reduce((acc, curr) => acc + curr.recieveQtyforstore, 0) || 0;
          const Allstatus = v.storeData?.[0]?.amountTotal.toString();
          const Allstatus1 = v.venderPayments?.[0]?.VendorPaymentDetails?.reduce(
            (total, payment) => total + Number(payment.VendorPaymentTotal),
            0
          ).toString();
          return (
            <Box className="padding_box" sx={{
              m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",
              overflowX: 'auto',
            }} key={v._id}
            >
              <Grid container item >
                {!isMobile && (
                  <Grid item sx={{ flexGrow: 1 }}>
                    <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1 }}>
                      <Box sx={{ width: '260px' }}>
                        <ul >
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Date</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}> Payment Against Invoice</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against PO</li>
                        </ul>
                      </Box>
                      <Box sx={{ width: '300px' }}>
                        <ul >
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {v.amountTotal}
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {
                              v.vendorDetails?.[0]?.businessName
                            }
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {
                              v.wareHouseDetails?.[0]?.wareHouseName
                            }
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {
                              (() => {

                                const percentage = ((Number(VendorPay?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / relatedStoreEntries?.amountTotal || 0;
                                return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(3)}%`;
                              })()
                            }
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                              ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                              : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                            }
                          </li>
                        </ul>
                      </Box>
                      <Box sx={{ width: '220px' }}>
                        <ul style={{ marginLeft: '30px' }}>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Payment</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>TDS/TCS</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Account Payment</li>
                          <li style={{ listStyleType: 'none', fontWeight: '600' }}>Pending Payment</li>
                        </ul>
                      </Box>
                      <Box sx={{ width: '200px' }}>
                        <ul >
                          <li style={{ listStyleType: 'none' }}>: &nbsp;{
                            relatedStoreEntries?.amountTotal || 0
                          }</li>

                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {
                              Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTDS), 0)) || 0
                            }
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {
                              Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0
                            }
                          </li>
                          <li style={{ listStyleType: 'none' }}>: &nbsp;
                            {relatedStoreEntries?.amountTotal - vedoerpending}
                          </li>
                        </ul>
                      </Box>
                      <Box sx={{ flexGrow: 1 }}>
                        <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center', justifyContent: "flex-end", flexGrow: 1 }}>
                          <Box
                            variant="contained"
                            sx={{
                              mr: 2, padding: "8px 12px", borderRadius: '4px', color: "white",
                              backgroundColor:
                                (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                  ? "#2c742c"
                                  : Allstatus === Allstatus1 && Allstatus !== undefined
                                    ? "#2c742c"
                                    : Allstatus1 < Allstatus
                                      ? "#a69041"
                                      : (Allstatus1 === undefined || Allstatus === undefined) ?
                                        "#9b2323" : "",
                              "&:hover": {
                                backgroundColor:
                                  (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                    ? "#2c742c"
                                    : Allstatus === Allstatus1 && Allstatus !== undefined
                                      ? "#2c742c"
                                      : Allstatus1 < Allstatus
                                        ? "#a69041"
                                        : (Allstatus1 === undefined || Allstatus === undefined) ?
                                          "#9b2323" : "",
                              },
                            }}
                          >
                            {(!relatedStoreEntries?.amountTotal && !Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)))
                              ? "Pending"
                              : (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                ? "Complete"
                                : Allstatus === Allstatus1
                                  ? "Complete"
                                  : Allstatus1 < Allstatus
                                    ? "Partial-Pending"
                                    : Allstatus1 === undefined || Allstatus === undefined ?
                                      "Pending" : ""}
                          </Box>

                          <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                            onClick={() => handleEdit(v._id, VendorPay?._id)}
                          >
                            <EditIcon />
                          </IconButton>

                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                )}
                {isMobile ? (
                  <>
                    <Grid item>
                      <Box sx={{ whiteSpace: 'pre-line', display: 'flex' }}>
                        <Box sx={{ width: '260px' }}>
                          <ul >
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Date</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Purchase Order Number</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>PO Value</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Vendor</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Ship To</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}> Payment Against Invoice</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Material Recived Against PO</li>
                          </ul>
                        </Box>
                        <Box sx={{ width: '300px' }}>
                          <ul >
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {v.PurchaseDate ? format(new Date(v.PurchaseDate), 'dd-MM-yyyy') : 'N/A'}
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.SrNo}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {v.amountTotal}
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {
                                v.vendorDetails?.[0]?.businessName
                              }
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {
                                v.wareHouseDetails?.[0]?.wareHouseName
                              }
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {
                                (() => {

                                  const percentage = ((Number(VendorPay?.VendorPaymentDetails.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0) * 100) / relatedStoreEntries?.amountTotal || 0;
                                  return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage.toFixed(3)}%`;
                                })()
                              }
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {((totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)) % 1 === 0)
                                ? `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(0)}%`
                                : `${(totalReceivedQty * 100 / (v.multipledata?.reduce((acc, item) => acc + Number(item.Qty), 0) || 1)).toFixed(2)}%`
                              }
                            </li>
                          </ul>
                        </Box>
                        <Box sx={{ width: '200px' }}>
                          <ul style={{ marginLeft: '0px' }}>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Total Payment</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>TDS/TCS</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Account Payment</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Pending Payment</li>
                          </ul>
                        </Box>
                        <Box sx={{ width: '200px' }}>
                          <ul >
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{
                              relatedStoreEntries?.amountTotal || 0
                            }</li>

                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {
                                Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTDS), 0)) || 0
                              }
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {
                                Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) || 0
                              }
                            </li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;
                              {relatedStoreEntries?.amountTotal - vedoerpending}
                            </li>
                          </ul>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                          <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', alignItems: 'center' }}>
                            <Box
                              variant="contained"
                              sx={{
                                mr: 2, padding: "8px 12px", borderRadius: '4px', color: "white",
                                backgroundColor:
                                  (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                    ? "#2c742c"
                                    : Allstatus === Allstatus1 && Allstatus !== undefined
                                      ? "#2c742c"
                                      : Allstatus1 < Allstatus
                                        ? "#a69041"
                                        : (Allstatus1 === undefined || Allstatus === undefined) ?
                                          "#9b2323" : "",
                                "&:hover": {
                                  backgroundColor:
                                    (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                      ? "#2c742c"
                                      : Allstatus === Allstatus1 && Allstatus !== undefined
                                        ? "#2c742c"
                                        : Allstatus1 < Allstatus
                                          ? "#a69041"
                                          : (Allstatus1 === undefined || Allstatus === undefined) ?
                                            "#9b2323" : "",
                                },
                              }}
                            >
                              {(!relatedStoreEntries?.amountTotal && !Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)))
                                ? "Pending"
                                : (relatedStoreEntries?.amountTotal - Number(VendorPay?.VendorPaymentDetails?.reduce((total, payment) => total + Number(payment.VendorPaymentTotal), 0)) < 0)
                                  ? "Complete"
                                  : Allstatus === Allstatus1
                                    ? "Complete"
                                    : Allstatus1 < Allstatus
                                      ? "Partial-Pending"
                                      : Allstatus1 === undefined || Allstatus === undefined ?
                                        "Pending" : ""}
                            </Box>

                            <IconButton aria-label="edit" style={{ color: "white", backgroundColor: "#134670" }} sx={{ mr: 2, bgcolor: '#134670', padding: "10px" }}
                              onClick={() => handleEdit(v._id, VendorPay?._id)}
                            >
                              <EditIcon />
                            </IconButton>

                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <>

                  </>
                )}
              </Grid>
            </Box >
          )
        })
      ) : (
        <Box>
          <Typography variant="h5" color="textSecondary" align="center">
            No Results Found. Please Try a Different Filter Term.
          </Typography>
        </Box>
      )}

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {isImage ? (
            <img src={fileUrl} alt="Preview" style={{ width: '500px', height: '600px', objectFit: 'contain' }} />
          ) : (
            <iframe src={fileUrl} width="500px" height="600px" title="PDF Viewer" />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box >
  );
}
export default Venderpayment;
